import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import { CopyButton } from "./copy-button";

interface CopyableIdProps {
  id: string;
  ariaLabel: string;
  className?: string;
}

const truncate = (id: string): string => {
  const parts = id.split("-");
  if (parts.length < 2) return id;
  return `…${parts[parts.length - 1]}`;
};

export const CopyableId = ({ id, ariaLabel, className }: CopyableIdProps) => {
  const { t } = useTranslation();
  const truncated = useMemo(() => truncate(id), [id]);

  return (
    <div className={cn("flex items-center gap-1 min-w-0", className)}>
      <span className="font-mono truncate" title={id}>
        {truncated}
      </span>
      <CopyButton value={id} label={t(ariaLabel)} />
    </div>
  );
};
